/**
 * FullWidthExtractor Module
 *
 * Extracts specific blocks from inside .grid-wrapper and moves them
 * to .full-width-content when they are the last child of their container.
 *
 * This fixes layout issues where full-width blocks inside the grid
 * interfere with sticky aside positioning.
 */

export default class FullWidthExtractor {
  constructor(app, opts = {}) {
    this.app = app
    this.opts = {
      // Selector for blocks to extract
      blockSelector: '[b-tpl="articleEntrances"]',
      // Selector for the container to check (must be last child of this)
      containerSelector: '.block-wrapper.has-aside-navigation',
      // Target to move blocks to
      targetSelector: '.full-width-content',
      ...opts,
    }

    // Track extracted blocks for cleanup
    this.extractedBlocks = []

    this.init()
  }

  init() {
    this.extract()
  }

  /**
   * Find and extract qualifying blocks
   */
  extract() {
    const containers = document.querySelectorAll(this.opts.containerSelector)

    containers.forEach(container => {
      // Get the last element child (ignoring text nodes)
      const lastChild = container.lastElementChild

      if (!lastChild) return

      // Check if it matches our block selector
      if (!lastChild.matches(this.opts.blockSelector)) return

      // Find the target (full-width-content)
      const target = document.querySelector(this.opts.targetSelector)

      if (!target) {
        console.warn('[FullWidthExtractor] No target found:', this.opts.targetSelector)
        return
      }

      // Move the block to the target
      target.appendChild(lastChild)

      // Track for potential cleanup
      this.extractedBlocks.push({
        block: lastChild,
        originalParent: container,
        target: target,
      })

      console.log('[FullWidthExtractor] Extracted block to full-width-content:', lastChild)
    })
  }

  /**
   * Called after view transitions to re-run extraction
   * since the DOM may have been replaced
   */
  refresh() {
    // Clear tracked blocks (they're gone after navigation)
    this.extractedBlocks = []

    // Re-run extraction
    this.extract()
  }

  /**
   * Restore blocks to original positions (if needed for cleanup)
   */
  restore() {
    this.extractedBlocks.forEach(({ block, originalParent }) => {
      if (block.parentNode && originalParent) {
        originalParent.appendChild(block)
      }
    })
    this.extractedBlocks = []
  }
}
